module.exports = function (number, digits, signed) {
  var result

  if (digits === null || digits === undefined) {
    digits = 0
  }

  if (signed === null || signed === undefined) {
    signed = true
  }

  digits = parseInt(digits)

  if (number === null || number === '' || isNaN(number)) {
    result = '-'
  } else {
    result = number.toLocaleString('fr-FR', {style: 'percent', maximumFractionDigits: digits})
    if (number > 0) {
      result = '+ ' + result
    }
  }

  if(!signed)
  {
    result = result.slice(1).trim()
  }

  return result
}
